module.exports = __webpack_public_path__ + "static/media/arrow-right-solid.6843c92a.svg";